import { object, string } from "yup";

import { parseCurrencyToNumber } from "../../helpers/currency";

export const changeAmountSchema = object({
    amount: string()
        .required("Valor é obrigatório")
        .test(
            "greater-than-zero",
            "O valor deve ser maior que zero",
            (value) => {
                const numericValue = parseCurrencyToNumber(value || "");
                return numericValue > 0;
            }
        ),
    admin_note: string().max(100, "Máximo de 100 caracteres").nullable(),
});
